import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { useAuth } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ROTULO = { 'marcou': 'marcou ✓', 'desfez': 'desfez o ✓', 'sem pendência': 'zerou sozinho' };

// Histórico das verificações (Adnéia, 17/10/2026): quem marcou o ✓ de um status ou
// atividade, quem desfez e quando, nos últimos 30 dias. alvo = { motivo, parceiro }.
const HistoricoVerificacao = ({ alvo, onClose }) => {
  const { getAuthHeader } = useAuth();
  const [linhas, setLinhas] = useState(null);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!alvo) return;
    setLinhas(null); setErro('');
    axios.get(`${API_URL}/api/dashboard/verificacao-historico`,
      { params: { motivo: alvo.motivo, parceiro: alvo.parceiro || '' }, headers: getAuthHeader() })
      .then(r => setLinhas(r.data.linhas || []))
      .catch(() => setErro('Não carregou o histórico. Tente de novo.'));
  }, [alvo, getAuthHeader]);

  const quando = (iso) => {
    try { return new Date(iso).toLocaleString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); }
    catch { return '?'; }
  };

  return (
    <Dialog open={!!alvo} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Histórico: {alvo?.motivo}{alvo?.parceiro ? ` · ${alvo.parceiro}` : ''}</DialogTitle>
          <DialogDescription>Quem marcou o ✓ e quando, nos últimos 30 dias. O histórico começa no dia em que esta versão do ELO entrou no ar.</DialogDescription>
        </DialogHeader>
        {erro && <p className="text-sm text-red-600">{erro}</p>}
        {!erro && linhas === null && <p className="text-sm text-muted-foreground flex items-center gap-2"><RefreshCw className="h-4 w-4 animate-spin" /> Carregando…</p>}
        {linhas && linhas.length === 0 && <p className="text-sm text-muted-foreground">Nada registrado ainda.</p>}
        {linhas && linhas.length > 0 && (
          <table className="w-full text-sm">
            <tbody>
              {linhas.map((l, i) => (
                <tr key={i} className="border-b last:border-0">
                  <td className="py-1.5 pr-3 whitespace-nowrap text-muted-foreground">{quando(l.em)}</td>
                  <td className="py-1.5 pr-3 font-medium">{l.por || '?'}</td>
                  <td className={`py-1.5 ${l.acao === 'desfez' ? 'text-red-600' : 'text-emerald-700 dark:text-emerald-300'}`}>{ROTULO[l.acao] || l.acao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default HistoricoVerificacao;
